import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { PUBLIC_ROUTES as PUBLIC_ROUTE_CONSTANTS } from '../route-constants';

const ReminderResponseScreen = lazy(() => import('@~/screens/reminder-response'));
const MonthlyProgressReportV2 = lazy(
  () => import('@~/screens/monthly-progress-report-v2'),
);
const ParentFeedback = lazy(() => import('@~/screens/parent-feedback'));
const PuzzlePreviewPage = lazy(() => import('@~/pages/puzzle-app/puzzle-app'));
const MathQuizReportPublic = lazy(
  () => import('@~/pages/mathfit-quiz-report/mathfit-quiz-report-public'),
);

export const PUBLIC_ROUTES: RouteObject = {
  children: [
    {
      path: PUBLIC_ROUTE_CONSTANTS.REMINDER_RESPONSE.PATH,
      element: <ReminderResponseScreen />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.REMINDER_RESPONSE.NAME,
      },
    },
    {
      path: PUBLIC_ROUTE_CONSTANTS.MONTHLY_PROGRESS_REPORT.PATH,
      element: <MonthlyProgressReportV2 />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.MONTHLY_PROGRESS_REPORT.NAME,
      },
    },
    {
      path: PUBLIC_ROUTE_CONSTANTS.PROGRESS_REPORT.PATH,
      element: <MonthlyProgressReportV2 />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.PROGRESS_REPORT.NAME,
      },
    },
    {
      path: PUBLIC_ROUTE_CONSTANTS.PARENT_FEEDBACK.PATH,
      element: <ParentFeedback />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.PARENT_FEEDBACK.NAME,
      },
    },
    {
      path: PUBLIC_ROUTE_CONSTANTS.PUZZLE_APP_PREVIEW.PATH,
      element: <PuzzlePreviewPage />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.PUZZLE_APP_PREVIEW.NAME,
      },
    },
    {
      path: PUBLIC_ROUTE_CONSTANTS.MATHQUIZ_REPORT.PATH,
      element: <MathQuizReportPublic />,
      handle: {
        pageName: PUBLIC_ROUTE_CONSTANTS.MATHQUIZ_REPORT.NAME,
      },
    },
  ],
};
